<template>
    <div class="customer-view">
        <v-row>
            <v-col cols="12" md="12" lg="4" xl="4">
                <div class="card border rounded px-4 py-3">
                    <CustomerDetail
                        @tab-selected="handleTabSelection"
                    />
                </div>
            </v-col>
            <v-col cols="12" md="12" lg="8" xl="8" >
                <div class="card border-0  px-0 py-0 bg-transparent">
                    <CustomerTabs :activeTab="activeTab" @tab-selected="handleTabSelection"/>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CustomerDetail from './customerDetail.vue';
import CustomerTabs from './customerTabs.vue';

export default {
    name: 'CustomerView',
    components: {
        CustomerDetail,
        CustomerTabs
    },
    data() {
    return {
      activeTab: 'Activity', // Default active tab
    };
  },
  methods: {
    handleTabSelection(tabName) {
        console.log('tab view ', tabName);
        
      this.activeTab = tabName;
    },
  },
}
</script>